/**
 * Brand-canonical gradients (strikeUp Brand Style Guide v1.0).
 *
 * Two named gradients ship with the brand. Use heroBlue on dashboard page
 * headers, marketing-style hero sections, and any surface where the brand
 * energy is required. Use heroGrey for quieter surfaces or when blue would
 * compete with chart colour.
 *
 * Angle is 135deg by convention (top-left → bottom-right) — this matches the
 * cover slide of the brand guide.
 */

export const gradients = {
  heroBlue: "linear-gradient(135deg, #1D1D1F 0%, #3B82F6 100%)",
  heroGrey: "linear-gradient(135deg, #1D1D1F 0%, #565656 100%)",
} as const;

export type GradientToken = keyof typeof gradients;
